import { Result, failure, success } from '../shared'
import { LoanProvider } from './loan.provider'
import {
  LoanSearchParams,
  LoanSearchServerData,
  LoanViewParams,
  LoanViewServerData,
  UpdateCommentsParams,
  AddNoteParams,
  EditNoteParams,
  DeleteNoteParams,
  AddEditMonitoringParams,
  DeleteMonitoringParams,
  UpdateCustomFieldsParams,
  LoanCoverParams,
  LoanCoverServerData,
  LoanFailure,
  LoanServiceErrorCode,
  LoanAddParams,
  LoanAddServerData,
  LoanScheduleParams,
  LoanScheduleServerData,
  LoanRestRShortParams,
  LoanRestRServerData,
  LoanOperParams,
  LoanOperServerData,
} from './loan.types'

export class LoanService {
  constructor(private provider: LoanProvider) {}

  public async loanSearch(params: LoanSearchParams): Promise<Result<LoanSearchServerData, LoanFailure>> {
    try {
      const { data } = await this.provider.loanSearch(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async loanView(params: LoanViewParams): Promise<Result<LoanViewServerData, LoanFailure>> {
    try {
      const { data } = await this.provider.loanView(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async loanOper(params: LoanOperParams): Promise<Result<LoanOperServerData, LoanFailure>> {
    try {
      const { data } = await this.provider.loanOper(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async loanRestRShort(params: LoanRestRShortParams): Promise<Result<LoanRestRServerData, LoanFailure>> {
    try {
      const { data } = await this.provider.loanRestRShort(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async updateComments(params: UpdateCommentsParams): Promise<Result<void, LoanFailure>> {
    try {
      await this.provider.updateComments(params)
      return success()
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async addNote(params: AddNoteParams): Promise<Result<void, LoanFailure>> {
    try {
      await this.provider.addNote(params)
      return success()
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async editNote(params: EditNoteParams): Promise<Result<void, LoanFailure>> {
    try {
      await this.provider.editNote(params)
      return success()
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async deleteNote(params: DeleteNoteParams): Promise<Result<void, LoanFailure>> {
    try {
      const { data } = await this.provider.deleteNote(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async addEditMonitoring(params: AddEditMonitoringParams): Promise<Result<void, LoanFailure>> {
    try {
      const { data } = await this.provider.addEditMonitoring(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async deleteMonitoring(params: DeleteMonitoringParams): Promise<Result<void, LoanFailure>> {
    try {
      const { data } = await this.provider.deleteMonitoring(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async updateCustomFields(params: UpdateCustomFieldsParams): Promise<Result<void, LoanFailure>> {
    try {
      const { data } = await this.provider.updateCustomFields(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async loanCover(params: LoanCoverParams): Promise<Result<LoanCoverServerData, LoanFailure>> {
    try {
      const { data } = await this.provider.loanCover(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async loanAdd(params: LoanAddParams): Promise<Result<LoanAddServerData, LoanFailure>> {
    try {
      const { data } = await this.provider.loanAdd(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async loanSchedule(params: LoanScheduleParams): Promise<Result<LoanScheduleServerData, LoanFailure>> {
    try {
      const { data } = await this.provider.loanSchedule(params)
      return success(data)
    } catch (error) {
      return failure(LoanServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
